(function($){
    var $fn = $(".comp_career_positions");

    if ($fn.length) {
        $fn.on("click", "[data-href]", function(e){
            e.preventDefault();
            window.location.href = $(this).data("href");
        });
    }
})(jQuery);